import { saveAs } from 'file-saver';
import {exportDetailSales, exportSales} from '~/apps/pos/apis/sales';

export const downloadSaleCSV = async (dtStart, dtEnd) => {
  const blob = await exportSales(dtStart, dtEnd);
  saveAs(blob, 'sales.csv');
};

export const downloadDetailSalesCSV = async (dtStart, dtEnd) => {
  const blob = await exportDetailSales(dtStart, dtEnd);
  saveAs(blob, 'detailSales.csv');
}
